import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 580E85A8-696F-46FE-B141-F13A94078F22
 * name format-text-rotation-down
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-text-rotation-down.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatTextRotationDownIcon = createSvgIcon(<><path d="M6,19.73L3,16.73H5V4.27H7V16.73H9L6,19.73M14,9.38V13.13L19.03,11.25L14,9.38M21,12L10,16.73V14.67L12.19,13.73V8.77L10,7.83V5.77L21,10.5V12Z" /></>, 'FormatTextRotationDownIcon');
export default FormatTextRotationDownIcon